import React from 'react';
import PropTypes from 'prop-types';

/**
 * Compact "active of total" stat tile (Brands / Branches / Aggregators / Market).
 * Clean white card with the active figure as the hero, total muted, and a thin
 * brand progress bar for the active/total ratio — consistent with the KPI
 * breakdown bars. Replaces the old purple/green block pair.
 */
const MetricsCard = ({ title, total, activeCount }) => {
  const totalNum = Number(total) || 0;
  const activeNum = Number(activeCount) || 0;
  const pct = totalNum > 0 ? Math.min(100, (activeNum / totalNum) * 100) : 0;

  return (
    <div
      className="rounded-lg border border-grey bg-white p-4"
      style={{ boxShadow: 'var(--sc-shadow-card)' }}
    >
      <div className="text-sm font-medium text-grey-darker">{title}</div>
      <div className="mt-2 flex items-baseline gap-x-1">
        <span className="sc-tabular-nums text-2xl font-bold leading-none text-black">
          {activeNum}
        </span>
        <span className="sc-tabular-nums text-sm text-grey-darker">
          / {totalNum} active
        </span>
      </div>
      <div className="mt-3 h-1 overflow-hidden rounded-full bg-grey-light">
        <div
          className="h-1 rounded-full bg-primary"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
};

MetricsCard.propTypes = {
  title: PropTypes.string,
  activeCount: PropTypes.any,
  total: PropTypes.any,
};
export default MetricsCard;
